document.addEventListener('DOMContentLoaded', async function () {

	function getEmptyJobsHTML() {
		return (`<div class="jobs_widget__bordered-container">
				<div class="jobs_widget__no-job-content">
						<div class="jobs_widget__no-job-content-heading">AKTUELL HABEN WIR KEINE OFFENEN STELLEN ZU BESETZEN.</div>
						<div class="jobs_widget__no-job-content-subtitle">Gerne können Sie sich initiativ bewerben.</div>
				</div>
		</div>`);
	}

	function updateJobsContainer(element, contentHTML) {
		const container = element.querySelector('.jobs_widget__jobs-listing');
		const showSpinner = element.querySelector('.jobs_widget__show-spinner');
		if (container) {
			container.innerHTML = contentHTML;
			showSpinner.style.display = 'none';
			container.style.display = 'block';
		} else {
			console.error('Container element not found.');
		}
	}

	async function fetchJobWidgetData(element, url) {
		try {
			// Fetch XML data
			const response = await fetch(url);
			const xmlText = await response.text();

			// Parse XML
			const parser = new DOMParser();
			const xmlDoc = parser.parseFromString(xmlText, 'application/xml');

			// Extract job information
			const jobs = xmlDoc.querySelectorAll('job');
			const detailPageURL = element.getAttribute("data-detail-page-url");

			if (jobs){
				let jobsDataHTML = '';
				jobs.forEach((job, index) => {
					const id = job.querySelector('id')?.textContent;
					const name = job.querySelector('name')?.textContent;
					const subTitle = job.querySelector('subTitle')?.textContent;
					const subTitleHTML = subTitle ? `<div class="jobs_widget__job-content-job-sub-title">${subTitle}</div>` : '';

					if (id && name) {
						jobsDataHTML += `<div class="jobs_widget__bordered-container">
                            <a target="_self" href="${detailPageURL}?id=${id}">
															<div class="jobs_widget__job-content">
																	<div class="jobs_widget__job-content-job-title">${name}</div>
																	${subTitleHTML}
															</div>
                            </a>
                        </div>`;
					}
				});
				updateJobsContainer(element, jobsDataHTML);
			} else {
				updateJobsContainer(element, getEmptyJobsHTML());
			}
		} catch (error) {
			console.error('Error fetching or parsing XML:', error);
		}
	}

	let jobWidgetSourceURLs = document.querySelectorAll(".jobs_widget--source-url");
	if (jobWidgetSourceURLs.length > 0) {
		for (const jobWidgetSourceURL of jobWidgetSourceURLs) {
			const sourceURL = jobWidgetSourceURL.getAttribute("data-source-url");
			if (sourceURL){
				await fetchJobWidgetData(jobWidgetSourceURL, sourceURL);
			}
		}
	}
});
